var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content wrapper"},[_c('user-setup-form',{attrs:{"submit-button-text":'Save Changes',"success-handler":_vm.success,"original-account":_vm.originalAccount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }